<template>
  <div class="container" id="carefully">
    <div class="header flex-cen flex-ter rel">
      <img class="logo abs" v-if="isJA()" src="https://static-jp.theckb.com/static-asset/client/bannerLogo.svg" alt="">
      <img class="banner-icon" src="@/assets/image/home-selected-banner-icon.png" alt="">
      <span class="title">{{ t('THE CKB官方精选商品') }}</span>
      <div @click="retractClick()" class="retract abs flex-cen flex-ter">
        {{ retract ? t('展开') : t('收起') }}
        <i :class="`iconfont ${!retract ? 'icon-chakanwuliuguiji_shouqi' : 'icon-chakanwuliuguiji_zhankai'}`"></i>
      </div>
    </div>
    <el-collapse-transition>
      <div class="content" v-show="!retract">
        <div class="topic">{{ t('1. 1688什么是官方精选供应商') }}</div>
        <div class="detail">{{ t('是1688官方选定的价格更具竞争力的人气供应商。') }}</div>
        <div class="subTitle">■{{ t('精选供应商的特点') }}</div>
        <div class="detail">
          <div>·{{ t('良品率高') }}</div>
          <div>·{{ t('价格比其他店铺有优势') }}</div>
          <div>·{{ t('拥有人气畅销商品') }}</div>
        </div>
        <div class="subTitle">■{{ t('1688严格挑选的供应商保证以下条件') }}</div>
        <div class="detail">
          <div>·{{ t('48小时内店铺发货') }}</div>
          <div>·{{ t('7天无条件退货') }}</div>
          <div>·{{ t('加快退款速度') }}</div>
        </div>
        <div class="topic">{{ t('2. 什么是受欢迎的商品') }}</div>
        <div class="detail">{{ t('1688根据公式保留的内部数据，我们分析客户的购买历史，偏好，趋势等，并预测客户可能感兴趣的产品。') }}</div>
        <template v-if="isJA()">
          <div class="topic">{{ t('3. 为什么我们可以给予低价?') }}</div>
          <div class="detail">{{ t('严格挑选的特别价格只对特定合作伙伴、企业共享。') }}</div>
          <div class="detail">{{ t('THE CKB通过与1688的业务合作，作为特定企业可以以特别价格购买商品，也可以提供给THE CKB的会员') }}</div>
        </template>
        <div class="topic">{{ t('4. 优点是什么') }}</div>
        <div class="detail">{{ t('根据1所描述的精选供应商的内容和条件，可以缩短订单的交货期，提高良品率。') }}</div>
      </div>
    </el-collapse-transition>
  </div>
</template>

<script setup>
import { onMounted, ref } from 'vue'
import { t } from '@/plugins/i18n'
import bus from '@/util/useBus'
import { isJA } from '@/store'
const storageRetract = localStorage.getItem('__selected_retract__') || false
// 是否收起
const retract = ref(storageRetract)

// 收起点击
const retractClick = (open = !retract.value) => {
  retract.value = open
  if (!localStorage.getItem('__selected_retract__')) {
    localStorage.setItem('__selected_retract__', true)
  }
}

onMounted(() => {
  bus.on('goCarefully', () => {
    document.querySelector('#carefully').scrollIntoView({ block: 'center', behavior: 'smooth' })
    retractClick(false)
  })
})

</script>

<style lang="scss" scoped>
.container {
  .header {
    background: url(../../../assets/image/goods/good-selected-banner.png);
    background-size: 100% 100%;
    height: 70px;

    .logo {
      left: 20px;
      top: 12px;
      width: 161px;
    }

    .banner-icon {
      width: 32px;
      height: 20px;
      margin-top: -20px;
    }

    .retract {
      right: 20px;
      top: 22px;
      padding: 0 10px;
      height: 25px;
      background: rgba(255, 255, 255, 0.2);
      border-radius: 13px;
      font-size: 12px;
      font-weight: 600;
      color: #FFFFFF;
      line-height: 25px;
      cursor: pointer;

      .iconfont {
        font-size: 10px;
        font-weight: 100;
        margin-left: 3px;
      }
    }

    .title {
      font-size: 26px;
      font-weight: 800;
      color: #FFFFFF;
      line-height: 38px;
      text-shadow: 0px 2px 8px #BA4200;
      background: linear-gradient(360deg, #FFE2CB 0%, #FFFFFF 100%);
      -webkit-background-clip: text;
    }
  }

  .content {
    background: linear-gradient(180deg, #FFFFFF 0%, #FFF3EA 100%);
    border-radius: 0px 0px 4px 4px;
    box-sizing: border-box;
    padding: 20px;

    .topic {
      font-size: 14px;
      font-weight: 500;
      color: #333333;
      line-height: 20px;

      &:nth-child(n+2) {
        margin-top: 16px;
      }
    }

    .detail,
    .subTitle {
      font-size: 12px;
      font-weight: 400;
      color: #777777;
      line-height: 17px;
      margin-top: 4px;
    }

    .detail {
      color: #777777;
    }

    .subTitle {
      color: #333333;
    }
  }
}
</style>
